import React from 'react'

const MoreAboutUs = () => {
  return (

    <section className='flex flex-col md:flex-row lg:mx-52 mt-40 items-center '>
      <div className='flex-1 flex  items-center justify-end'>
        <img alt='lorem' className='block w-full' src='https://assets.packlane.com/jExsMzb0DS0Q68-jPKykvLHi3XH3jOWKKesLwblbwKY/w:1000/fn:homepage-about/czM6Ly9wYWNrbGFuZS1hc3NldHMvcHJvZHVjdGlvbi9hcHAvaW1hZ2VzL2hvbWVwYWdlLWFib3V0LmpwZw.jpg' />
      </div>
      <div className='flex-1 mt-32 lg:mt-0 text-center sm:text-left'>
        <h2 className='font-tiempo text-azul font-semibold mx-12 text-4xl'>More than just a pretty package</h2>
        <p className=' font-basis font-bold text-gray-1 mx-8 sm:mx-12  py-4 text-xl'>Customizable from the inside out, every custom printed box we create is made just for you – and with your customers in mind. Make a statement in the mail or on display with an unboxing experience unlike any other. Your products deserve custom packaging boxes crafted with sustainable materials, impeccable print quality, and picture-perfect design. Create packaging that wows no matter your use-case, business, or industry.</p>
        <a href="/" className='bg-gray-sm block py-4 px-8 my-8 mx-12 rounded-full text-center text-azul font-basis text-gray-1 font-bold font-bold tracking-widest uppercase text-sm max-w-500'>FIND OUT WHAT MAKES OUR BOXES SPECIAL </a>
      </div>
    </section>

  )
}

export default MoreAboutUs
